const STICKY_CLASS = 'Header--sticky';
const WHITE_CLASS = 'Header--white';
const headerOffset = 50;
const header = document.querySelector('.Header');

const toggleSticky = () => {
    window.scrollY > headerOffset
        ? header.classList.add(STICKY_CLASS)
        : header.classList.remove(STICKY_CLASS);
};

window.addEventListener('scroll', toggleSticky);

header.classList.add(STICKY_CLASS);

const body = document.querySelector('body');
const pageIds = [266, 355];
window.addEventListener('load', () => {
    pageIds.forEach((id) => {
        if (
            Array.from(body.classList).some(
                (className) =>
                    className === `page-id-${id}` ||
                    className === 'tax-kategoria-inwestycji' ||
                    className === 'single-mieszkania' ||
                    className === 'page-template-page-rodo',
            )
        )
            header.classList.add(WHITE_CLASS);
    });
});
